<script lang="ts" setup>
export interface WidgetHelpdeskProps {
    size?: 'normal' | 'big'
    iconSize: number
    iconWrapperSize: number
}

const props = withDefaults(defineProps<WidgetHelpdeskProps>(), {
    size: 'normal',
})
</script>
<template>
  <Card
    box-shadow="3"
    classes="rounded overflow-hidden"
  >
    <Tracker :data="{ position: $t('Potrebujete pomôcť?') }">
      <section
        class="row g-0 align-items-center"
        :class="`widget-helpdesk-${props.size}`"
      >
        <div
          class="widget-helpdesk-heading position-relative col-12 col-lg-4 col-xl-auto mb-0 p-6 px-md-10"
        >
          <Heading
            level="h3"
            class="mb-2 text-white"
            :class="{
              beta: props.size === 'big',
              delta: props.size === 'normal',
            }"
          >
            <slot name="title" />
          </Heading>
          <div class="d-flex align-items-center">
            <VNuxtLink
              :to="useNamedRoutes({ name: 'contacts' })"
              class="stretched-link text-white d-flex align-items-center fw-bolder fs-normal"
              :label="$t('Kontakty')"
            >
              <slot name="subtitle" />
              <svg
                class="ms-2 text-white d-block transition"
                width="6"
                height="12"
                aria-hidden="true"
              >
                <use xlink:href="#angle-right" />
              </svg>
            </VNuxtLink>
          </div>
        </div>
        <div class="col-12 col-lg-8 col-xl-6 flex-grow-1 h-100">
          <div
            class="row g-0 px-6 pb-6 pt-8 py-md-8 py-lg-4 pe-md-0 ps-md-10 ps-xl-15"
          >
            <div class="col-12 col-md-6">
              <IconText
                :size="props.size"
                :label="$t('Telefonický kontakt')"
                value="+421 2 5729 9999"
                link="tel:+421257299999"
                class="mb-4 mb-md-0"
              >
                <template #icon-desktop>
                  <icon-rounded-wrapper
                    :size="props.iconWrapperSize"
                  >
                    <svg
                      class="d-block text-secondary"
                      aria-hidden="true"
                      :width="props.iconSize"
                      :height="props.iconSize"
                    >
                      <use xlink:href="#phone" />
                    </svg>
                  </icon-rounded-wrapper>
                </template>
                <template #icon-mobile>
                  <svg
                    aria-hidden="true"
                    class="d-block text-secondary"
                    width="16"
                    height="16"
                  >
                    <use xlink:href="#phone" />
                  </svg>
                </template>
              </IconText>
            </div>
            <div class="col-12 col-md-6">
              <IconText
                :size="props.size"
                :label="$t('E-mailový kontakt')"
                :link="
                  useNamedRoutes({
                    name: 'contacts',
                    hash: '#napiste-nam',
                  })
                "
                :value="$t('Napíšte nám')"
              >
                <template #icon-desktop>
                  <icon-rounded-wrapper
                    :size="props.iconWrapperSize"
                  >
                    <svg
                      class="d-block text-secondary"
                      aria-hidden="true"
                      :width="props.iconSize"
                      :height="props.iconSize"
                    >
                      <use xlink:href="#email" />
                    </svg>
                  </icon-rounded-wrapper>
                </template>
                <template #icon-mobile>
                  <svg
                    aria-hidden="true"
                    class="d-block text-secondary"
                    width="16"
                    height="12"
                  >
                    <use xlink:href="#email" />
                  </svg>
                </template>
                <template #icon-link>
                  <svg
                    aria-hidden="true"
                    class="d-block ms-2 text-secondary transition"
                    width="8"
                    height="16"
                  >
                    <use xlink:href="#angle-right" />
                  </svg>
                </template>
              </IconText>
            </div>
          </div>
        </div>
      </section>
      <IconsWrapper>
        <IconsSymbolPhone />
        <IconsSymbolEmail />
        <IconsSymbolAngleRight />
      </IconsWrapper>
    </Tracker>
  </Card>
</template>
<style lang="scss">
@import './WidgetHelpdesk.vars.scss';
</style>
<style lang="scss" scoped>
@import './WidgetHelpdesk.scss';
</style>
